import type { Epic } from '@/features/project-board/types';

const KOREAN_TITLE: Readonly<Record<string, string>> = {
  'webapp-next-hardening': '웹앱 차세대 안정화',
  'webapp-design-system-phase2': '웹앱 디자인 시스템 2단계',
  'webapp-conversion': '웹앱 전환',
  'webapp-build-distribution': '웹앱 빌드·배포',
  'onnuri-transaction-lookup': '온누리 거래 조회',
  'github-actions-self-hosted-runner': 'GitHub Actions 자체 호스팅 러너',
  'dev-db-refresh-from-prod-backup': '운영 백업으로 개발 DB 갱신',
  'admin-wholesale-support-limit-lookup': '관리자 도매 지원 한도 조회',
  'ad-point-charge-consumption-tracking': '광고 포인트 충전·소진 추적',
  'ad-monitoring-ledger-enhancements': '광고 모니터링 원장 개선',
  'ad-application-blockout-days': '광고 신청 제외일 관리',
  'activity-log-separation': '활동 로그 분리',
  'wholesale-market-penetration': '도매 시장 진입',
  'wholesale-building-location': '도매 건물 위치 관리',
  'slack-ai-assistant-bot': 'Slack AI 어시스턴트 봇',
  'search-synonym-redesign': '검색 동의어 재설계',
  'search-exclude-soldout': '품절 상품 검색 제외',
  'product-impression-metrics': '상품 노출 지표',
  'pos-offline-bestseller-plp': 'POS 오프라인 베스트셀러 상품 목록',
  'payup-pg-retail-split-payment': '페이업 PG 소매 분할 결제',
  'ops-intake': '운영 이슈 접수',
  'mysql-8.4-upgrade': 'MySQL 8.4 업그레이드',
  'mobile-retail-web': '모바일 소매 웹',
  'integrated-tax-invoice-wholesaler-centric': '도매 중심 통합 세금계산서',
  'integrated-tax-invoice-multi-source': '복수 원천 통합 세금계산서',
  'corporate-website': '기업 홈페이지',
  'api-v3-camelcase-gateway': 'API v3 카멜 케이스 게이트웨이',
  'ai-dart-console-migration': 'AI-DART 콘솔 이전',
  'admin-bulk-price-adjust': '관리자 일괄 가격 조정',
  'shared-category': '공통 카테고리',
  'overseas-shipping-sheet-export': '해외 배송 시트 내보내기',
  'onnuri-payment': '온누리 결제',
  'image-watermark-exempt': '이미지 워터마크 예외 처리',
  'deleted-product-link-notice': '삭제 상품 링크 안내',
  'image-watermark': '이미지 워터마크',
  'ad-system': '남도마켓 도매 광고 시스템',
  'welfare-universal-link': '복지몰 유니버설 링크',
  'welfare-app-open-link': '복지몰 앱 열기 링크',
  'retail-campaign-ga-metrics': '소매 캠페인 GA 지표',
  'badge-seed': '뱃지 시드 데이터',
  'activity-log-raw-table-removal': '활동 로그 원본 테이블 제거',
  'onnuri-server-removal': '온누리 서버 제거',
  'link-service': '링크 서비스',
  'infra-kafka-on-gke': 'GKE 카프카 인프라',
  'es-selfhost-migration': 'Elasticsearch 자체 호스팅 이전',
  'onnuri-admin': '온누리 어드민',
  'wholesale-product-discount-registration': '도매 상품 할인 등록',
  'wholesale-pickup-address': '도매 픽업 주소',
  'own-universal-links': '자체 유니버설 링크',
  'next-webapp-product-market-ds-alignment': '차세대 웹앱 상품·마켓 디자인 시스템 정렬',
  'namdo-new-week-followup-features': '남도신상주간 후속 기능',
  'deferred-deep-link': '디퍼드 딥링크',
  'admin-refund-account-error-kakao-notice': '관리자 환불 계좌 오류 카카오 안내',
  'abr-link-replacement': 'ABR 링크 대체',
  'wholesale-new-arrival-week': '도매 신상주간',
  'welfare-share-meta-seo-url': '복지몰 공유 메타·SEO URL',
  'welfare-product-slug-links': '복지몰 상품 슬러그 링크',
  'welfare-lang-es-fr-ru': '복지몰 스페인어·프랑스어·러시아어 지원',
  'pos-sale-d1-apply': 'POS 판매 D1 적용',
  'minishop-member-handoff': '미니숍 회원 인계',
  'db-trigger-to-code': 'DB 트리거의 코드 전환',
  'chat-clipboard-image-paste': '채팅 클립보드 이미지 붙여넣기',
  'android-ui-fixes-logo-category-scrolltop': '안드로이드 로고·카테고리·맨 위로 UI 수정',
  'login-device-info': '로그인 기기 정보',
  'ad-product-exhibition-free-conversion': '광고 상품 기획전 무료 전환',
  'onnuri-settlement-recon': '온누리 정산 대사',
  'tax-invoice-link-wholesale-signup': '도매 가입 세금계산서 링크',
  'pos-screen-version-switch': 'POS 화면 버전 전환',
  'pos-sale-type-b': 'POS 판매 B유형',
  'openapi-ai-export': 'OpenAPI AI 내보내기',
  'bipum-mall': '비품몰',
  'ad-click-price-market-override': '광고 클릭 단가 마켓별 재정의',
  'pos-ndmarket-integration-v2': 'POS 남도마켓 연동 2차',
  'pengdi-conversational-product-search': '펭디 대화형 상품 검색',
  'marketing-dashboard-ga4-traffic': '마케팅 대시보드 GA4 트래픽',
  'es-bridge-incremental-preservation': 'ES 브릿지 증분 보존',
  'product-image-copyright-inspection': '상품 이미지 저작권 검수',
  'admin-product-bulk-category-update': '관리자 상품 카테고리 일괄 수정',
  'slack-bot-data-query-rag': '슬랙 봇 데이터 조회 RAG',
  'slack-bot-data-query': '슬랙 봇 데이터 조회',
  'marketing-dashboard-kpi-api': '마케팅 대시보드 KPI API',
  'link-conversion-attribution': '링크 전환 기여 분석',
  'android-chat-respect-font-scale': '안드로이드 채팅 글꼴 크기 반영',
  'welfare-institution-currency': '복지몰 기관 통화',
  'welfare-arabic-language': '복지몰 아랍어 지원',
  'link-cutover-deferred-compat': '링크 전환 디퍼드 호환',
  'link-analytics-rollup': '링크 분석 집계',
  'link-analytics-admin': '링크 분석 어드민',
  'season-trend': '시즌 트렌드',
  'pos-external-order-channels': 'POS 외부 주문 채널',
  'market-overseas-banner-popup-image': '마켓 해외 배너·팝업 이미지',
  'retail-signup-referral-source': '소매 가입 유입 경로',
  'welfare-mall-bulk-product-visibility': '복지몰 상품 노출 일괄 설정',
  'pengdi-hscode-japan-price': '펭디 HS코드 일본 가격',
  'admin-product-change-anomaly-clear': '관리자 상품 변경 이상 해제',
  'marketing-stats-monthly': '마케팅 월간 통계',
};

/** 영문 slug만 제목으로 색인된 진행 에픽은 대시보드용 한국어 이름으로 보여준다. */
export class DashboardEpicTitle {
  static of(epic: Epic): string {
    return KOREAN_TITLE[epic.slug] ?? (epic.title === epic.slug ? epic.slug.replace(/-/g, ' ') : epic.title);
  }
}
